import { cva } from "class-variance-authority";

// A row's states come from whichever primitive drives it, and Radix and cmdk mark them differently:
// - highlighted (under the pointer, or reached with the arrow keys): Radix sets `data-highlighted`, cmdk sets
//   `data-selected="true"` (and `"false"` otherwise, so the bare `data-selected` variant would match every row);
// - disabled: both set `aria-disabled="true"`; cmdk always sets `data-disabled`, `"false"` included, so it's no signal.
// A picked row carries `data-checked`, set by `MenuItem` itself.
export const menuItemVariants = cva(
  [
    "group", // Lets the slots follow the row's state, ex: group-aria-disabled
    "flex cursor-pointer items-center gap-2 rounded-lg px-3 py-2 font-sans text-sm font-normal outline-hidden select-none",
    "data-highlighted:bg-neutral-95 data-[selected=true]:bg-neutral-95",
    "aria-disabled:cursor-not-allowed",
    // A highlighted row highlights its unchecked checkbox, as hovering the checkbox itself would.
    "[&[data-highlighted]_button[role=checkbox][data-state=unchecked]:not(:disabled)]:border-primary-50",
    "[&[data-highlighted]_button[role=checkbox][data-state=unchecked]:not(:disabled)]:bg-primary-95",
    "[&[data-selected=true]_button[role=checkbox][data-state=unchecked]:not(:disabled)]:border-primary-50",
    "[&[data-selected=true]_button[role=checkbox][data-state=unchecked]:not(:disabled)]:bg-primary-95",
  ],
  {
    variants: {
      color: {
        default: ["text-neutral-10", "aria-disabled:text-neutral-80 aria-disabled:data-checked:text-neutral-70"],
        // A destructive row is highlighted in its own colour.
        error: "text-error-50 data-highlighted:bg-error-95 data-[selected=true]:bg-error-95",
      },
      // What marks a picked row: a tint and a trailing check, or a leading checkbox or radio.
      variant: {
        // The tint stays while the row is highlighted, and greys out with it when disabled.
        default: [
          "data-checked:bg-primary-98 data-checked:data-highlighted:bg-primary-98 data-checked:data-[selected=true]:bg-primary-98",
          "aria-disabled:data-checked:bg-neutral-95",
        ],
        checkbox: "",
        radio: "",
      },
    },
    defaultVariants: {
      color: "default",
      variant: "default",
    },
  }
);

// The `iconLeading` icon: grey, lighter with the disabled row; or the row's own colour.
export const menuItemIconVariants = cva("size-5 shrink-0", {
  variants: {
    color: {
      default: [
        "text-neutral-50",
        "group-aria-disabled:text-neutral-80 group-aria-disabled:group-data-checked:text-neutral-70",
      ],
      error: "text-error-50 group-aria-disabled:text-error-80 group-aria-disabled:group-data-checked:text-error-70",
    },
  },
  defaultVariants: {
    color: "default",
  },
});
